'use client';

import { BigNum, OrderTriggerCondition } from '@velocity-exchange/sdk';
import { ENUM_UTILS, MarketId } from '@velocity-exchange/common';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import useGetTickSizeForMarket, {
	getTickSizeDecimalPlaces,
} from 'src/hooks/useGetTickSizeForMarket';
import { AccountOrder } from '../types';

interface TriggerConditionCellProps {
	order: AccountOrder;
}

const EMPTY_VALUE = <span className="text-text-tertiary">-</span>;

export function TriggerConditionCell({ order }: TriggerConditionCellProps) {
	const getTickSizeForMarket = useGetTickSizeForMarket();
	const marketId = new MarketId(order.marketIndex, order.marketType);
	const tickSize = getTickSizeForMarket(marketId);
	const tickSizeDecimalPlaces = getTickSizeDecimalPlaces(tickSize);

	const triggerPriceToUse = order.triggerPrice as BigNum;

	if (triggerPriceToUse.eqZero()) {
		return EMPTY_VALUE;
	}

	const triggerConditionAbove =
		ENUM_UTILS.match(order.triggerCondition, OrderTriggerCondition.ABOVE) ||
		ENUM_UTILS.match(
			order.triggerCondition,
			OrderTriggerCondition.TRIGGERED_ABOVE
		);

	return (
		<div className="flex items-center gap-1">
			<span>{triggerConditionAbove ? '>' : '<'}</span>
			<NumberDisplay
				value={triggerPriceToUse}
				type="currency"
				decimals={tickSizeDecimalPlaces}
				trimZeroes
			/>
		</div>
	);
}
